import request from '@/utils/request';

export default {
  /**
   * 给面板添加组件
   * @param panelId
   * @param componentType 组件类型，可用COMPONENT_TYPE枚举
   * @return {*}
   * @see COMPONENT_TYPE
   */
  add(panelId, componentType) {
    return request.post('component/add', {
      panelId,
      type: componentType,
    });
  },
  /**
   * 设置标定输入组件的值
   * @param componentId
   * @param dataSource 数据源的key
   * @param value
   * @return {*}
   */
  setInputValue(componentId, dataSource, value) {
    return request.post('component/input/setValue', {
      componentId,
      datasource: dataSource,
      value,
    });
  },
  /**
   * 设置DBC-Message发送组件的里面的值。当循环发送时，会调用
   * @param componentId
   * @param values {Array}
   * @return {*|Promise<any>}
   */
  setSendValue(componentId, values) {
    return request.post('component/send/setValue', {
      id: componentId,
      data: values,
    });
  },
  /**
   * 立即发送一条DBC-Message发送组件的消息。当主动发送时，会调用
   * @param componentId
   * @param values
   * @return {*|Promise<any>}
   */
  sendMsg(componentId, values) {
    return request.post('component/send/sendMsg', {
      id: componentId,
      data: values,
    });
  },
  /**
   * 为组件上传图片
   * @param fileBlob
   * @param componentId
   * @return {*|Promise<any>}
   */
  uploadPic(fileBlob, componentId) {
    const data = new FormData();
    data.append('file', fileBlob);
    data.append('componentId', componentId);
    return request.postForm('component/uploadPic', data);
  },
  /**
   * 保存组件的图片信息
   * @param componentId
   * @param pictureInfos
   * @return {*|Promise<any>}
   */
  savePictureInfos(componentId, pictures) {
    return request.post('component/savePicInfo', {
      componentId,
      pictures,
    });
  },

  /**
   * 获取组件的图片信息
   * @param componentId
   * @return {*|Promise<any>}
   */
  getPictureInfos(componentId) {
    return request.post('component/getPicInfo', {
      componentId,
    });
  },

  /**
   * 保存组件的图片配置信息
   * @param componentId
   * @param config
   * @return {*|Promise<any>}
   */
  savePictureConfig(componentId, config) {
    return request.post('component/savePicConfig', {
      componentId, config,
    });
  },

  /**
   * 获取组件的图片配置信息
   * @param componentId
   * @return {*|Promise<any>}
   */
  getPictureConfig(componentId) {
    return request.post('component/getPicConfig', {
      componentId,
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/component.js